import React from "react";
import ComplianceDocument from "../components/ui/ComplianceDocument";

export default function CookiePolicyPage(): React.JSX.Element {
  return (
    <ComplianceDocument
      slug="cookie-policy"
      title="Cookie Policy"
      description={
        <span>
          This Cookie Policy explains how <strong>kivo.skin</strong> uses cookies and similar technologies when you visit our website or use our service.
        </span>
      }
    />
  );
}
